import { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";

const API_BASE_URL = process.env.REACT_APP_HOST_API || "http://localhost:4000";
const SOCKET_URL = API_BASE_URL.replace("/api/v1/", "").replace("/api/v1", "");

const OrangeMoneyModal = ({
  paymentUrl,
  orderId,
  onSuccess,
  onFailure,
  onClose,
}) => {
  const [message, setMessage] = useState(
    "En attente de confirmation du paiement...",
  );
  const socketRef = useRef(null);

  useEffect(() => {
    if (!orderId) return;

    const socket = io(SOCKET_URL);
    socketRef.current = socket;

    socket.emit("join-order", orderId);

    socket.on("paiement:update", ({ status }) => {
      if (status === 1) {
        setMessage("Paiement confirmé !");
        // Laisse le temps à l'interface Orange d'afficher son propre résultat
        setTimeout(() => {
          onSuccess?.();
        }, 2000);
      } else if (status === 3) {
        setMessage("Le paiement a échoué ou a été annulé.");
        setTimeout(() => {
          onFailure?.();
        }, 2000);
      }
    });

    const timeout = setTimeout(() => {
      setMessage("Le délai de paiement a expiré.");
      onFailure?.();
    }, 180000);

    return () => {
      clearTimeout(timeout);
      socket.disconnect();
    };
  }, [orderId]);

  return (
    <div className="orange_modal_overlay">
      <div className="orange_modal_content">
        <button className="orange_modal_close" onClick={onClose}>
          &times;
        </button>
        <p className="orange_modal_status">{message}</p>
        <iframe
          src={paymentUrl}
          title="Paiement Orange Money"
          className="orange_modal_iframe"
          frameBorder="0"
        />
      </div>
    </div>
  );
};

export default OrangeMoneyModal;
